var _rect, _rect2, _rect3, _text, _text2, _text3, _path, _circle, _circle2, _circle3, _circle4, _rect4, _text4, _rect5, _rect6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNexoraDigital(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 750",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 750,
    fill: "#111827"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 70,
    width: 1060,
    height: 610,
    rx: 26,
    fill: "#f5f7fa"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 70,
    width: 1060,
    height: 82,
    rx: 26,
    fill: "#263a5a"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 122,
    fontFamily: "Arial",
    fontSize: 28,
    fontWeight: 700,
    fill: "#fff"
  }, "NEXORA DIGITAL")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 250,
    fontFamily: "Arial",
    fontSize: 62,
    fontWeight: 700,
    fill: "#111827"
  }, "Ideas into momentum.")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 300,
    fontFamily: "Arial",
    fontSize: 23,
    fill: "#64748b"
  }, "Digital systems for ambitious teams.")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M780 470 900 220l80 145 95-105",
    fill: "none",
    stroke: "#f05d5e",
    strokeWidth: 24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 780,
    cy: 470,
    r: 22,
    fill: "#263a5a"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 900,
    cy: 220,
    r: 22,
    fill: "#263a5a"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 980,
    cy: 365,
    r: 22,
    fill: "#263a5a"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 1075,
    cy: 260,
    r: 22,
    fill: "#263a5a"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 420,
    width: 250,
    height: 64,
    rx: 32,
    fill: "#f05d5e"
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 183,
    y: 460,
    fontFamily: "Arial",
    fontSize: 20,
    fontWeight: 700,
    fill: "#fff"
  }, "See the system")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 545,
    width: 230,
    height: 55,
    rx: 12,
    fill: "#e4e9f0"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 380,
    y: 545,
    width: 230,
    height: 55,
    rx: 12,
    fill: "#e4e9f0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNexoraDigital);
export default __webpack_public_path__ + "static/media/nexora-digital.b9be7bac75444e68f094a5abdd116dfd.svg";
export { ForwardRef as ReactComponent };